<template>
  <div class="radio-button">
    <label :for="label" class="display-flex align-center">
      <bh-icon :icon="icon" :class="iconClasses"/>
      <input :id="label" class="radio"
        type="radio"
        :value="value"
        :checked="checked"
        :disabled="disabled"
        @click="emitValue(checked, value)">
      {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  name: 'bh-radio-button',
  props: {
    label: {
      type: String,
      default: 'Label'
    },
    checked: {
      type: Boolean,
      default: false
    },
    value: {
      default: ''
    },
    icon: {
      type: String,
      default: 'radio-unchecked'
    },
    iconClasses: {
      type: String,
      default: 'mr-5'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitValue(checked, value) {
      value = {
        checked: !checked,
        value: value
      }
      this.$emit('output', value)
    }
  }
}
</script>

<style scoped>
  .radio-button input[type=radio] {
    display: none;
  }
</style>
